<template>
  <div class="page-container animate-fade-in-up">
    <PageHeader icon="el-icon-reading" title="推荐课程管理" subtitle="管理报告中推荐的管理课程与资源" />

    <div class="toolbar">
      <el-input v-model="search" placeholder="搜索课程标题" prefix-icon="el-icon-search" clearable style="width: 280px;" />
      <el-button v-if="$hasPermission('course:create')" type="primary" icon="el-icon-plus" class="btn-click" style="margin-left: auto;" @click="openAdd">新增课程</el-button>
    </div>

    <div class="table-wrapper">
      <el-table :data="filteredList" stripe class="data-table">
        <el-table-column prop="course_id" label="ID" width="60" />
        <el-table-column prop="title" label="课程标题" min-width="200" show-overflow-tooltip />
        <el-table-column prop="desc" label="描述" min-width="240" show-overflow-tooltip />
        <el-table-column label="二维码" width="100">
          <template slot-scope="scope">
            <span style="color: var(--color-text-muted);">{{ scope.row.qr_url ? '已设置' : '未设置' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('course:edit')" type="text" class="action-edit" @click="openEdit(scope.row)">编辑</el-button>
            <el-button v-if="$hasPermission('course:delete')" type="text" class="action-disable" @click="remove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" :append-to-body="true">
      <el-form label-width="80px">
        <el-form-item label="课程标题"><el-input v-model="form.title" /></el-form-item>
        <el-form-item label="课程描述"><el-input type="textarea" v-model="form.desc" :rows="3" /></el-form-item>
        <el-form-item label="二维码URL"><el-input v-model="form.qr_url" placeholder="图片链接地址，留空则显示占位图标" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageHeader from '../../components/PageHeader.vue'

export default {
  name: 'CourseManage',
  components: { PageHeader },
  data() {
    return {
      search: '',
      dialogVisible: false,
      isEdit: false,
      form: { course_id: null, title: '', desc: '', qr_url: '' }
    }
  },
  computed: {
    list() {
      const taskId = this.$store.getters.currentTaskId
      const all = this.$store.state.cases.courses || []
      if (!taskId) return all
      return all.filter(c => c.task_id === taskId || !c.task_id)
    },
    filteredList() {
      if (!this.search) return this.list
      const k = this.search.toLowerCase()
      return this.list.filter(c => c.title.toLowerCase().includes(k) || c.desc.toLowerCase().includes(k))
    },
    dialogTitle() { return this.isEdit ? '编辑课程' : '新增课程' }
  },
  methods: {
    openAdd() {
      this.isEdit = false
      this.form = { course_id: null, title: '', desc: '', qr_url: '' }
      this.dialogVisible = true
    },
    openEdit(row) {
      this.isEdit = true
      this.form = { ...row }
      this.dialogVisible = true
    },
    save() {
      if (this.isEdit) {
        this.$store.commit('cases/UPDATE_COURSE', { ...this.form })
        this.$message.success('已更新')
      } else {
        this.$store.commit('cases/ADD_COURSE', { course_id: Date.now(), title: this.form.title, desc: this.form.desc, qr_url: this.form.qr_url })
        this.$message.success('已新增')
      }
      this.dialogVisible = false
    },
    remove(row) {
      this.$confirm('确定删除课程「' + row.title + '」？', '提示', { type: 'warning' }).then(() => {
        this.$store.commit('cases/DELETE_COURSE', row.course_id)
        this.$message.success('已删除')
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.toolbar { display: flex; align-items: center; margin-bottom: var(--space-lg); }
.table-wrapper { background: var(--color-surface); border: 1px solid var(--color-border); border-radius: var(--radius-lg); overflow: hidden; box-shadow: var(--shadow-sm); }
.data-table >>> th { background: var(--color-bg) !important; color: var(--color-text) !important; font-weight: 600 !important; }
.action-edit { color: var(--color-primary) !important; }
.action-disable { color: var(--color-high) !important; }
</style>
